import { useMemo } from "react";
import { calculateFullPricing, formatPence } from "../services/pricing.js";
export function useMovePricing(input) {
    return useMemo(() => {
        const result = calculateFullPricing(input);
        return {
            ...result,
            formatted: {
                servicePrice: formatPence(result.servicePrice),
                serviceFee: formatPence(result.serviceFee),
                subtotal: formatPence(result.subtotalAfterDiscount),
                vat: formatPence(result.vatAmount),
                customerTotal: formatPence(result.customerTotal),
                discount: formatPence(result.discount),
                commission: formatPence(result.commission),
                driverEarnings: formatPence(result.driverEarnings),
                platformRevenue: formatPence(result.platformRevenue),
                stripeFee: formatPence(result.stripeFee),
            },
        };
    }, [input]);
}
//# sourceMappingURL=useMovePricing.js.map